import React, {lazy, Suspense} from 'react'

const ExamenLazy = lazy(() =>
    import('./Examen')
)

const Examen = props => (
    <Suspense fallback={null}>
        <ExamenLazy {...props} />
    </Suspense>
)

export default Examen
